import { PlusOutlined, SettingOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import dayjs from "dayjs"
import React, { useState } from "react"

import type { CalendarModalData } from "../../redux/calendar.types.ts"
import { CalendarSettingsDrawer } from "./CalendarSettings/CalendarSettingsDrawer.tsx"

const { Title, Text } = Typography

interface CalendarHeaderProps {
  createAllowed?: boolean
  accountTimezone?: string | null
  onSetModalData: (data: CalendarModalData | null) => void
}

export function CalendarHeader({
  createAllowed,
  accountTimezone,
  onSetModalData
}: CalendarHeaderProps) {
  const [settingsOpen, setSettingsOpen] = useState(false)

  const onOpenAddModal = () => {
    const today = dayjs.tz()

    onSetModalData({
      date: today,
      start_at: null,
      end_at: null
    })
  }

  return (
    <div className="flex lg:items-center gap-3 max-lg:flex-col justify-between py-1">
      <Flex vertical gap={4}>
        <Title level={3} className={"text-start mb-0 font-bold !text-2xl"}>
          Calendar & Appointments
        </Title>
        <Text type={"secondary"} className={"text-sm"}>
          Manage lead meetings, site visits, and follow-ups
        </Text>
      </Flex>

      <Flex gap={8} align={"center"}>
        {/* A real labeled button, not an icon-only control — a bare gear
            here reads as the app's own global Settings (top-right of the
            shell), leaving no way to tell the two apart at a glance. */}
        <Button
          size={"large"}
          aria-label={"Calendar Settings"}
          aria-pressed={settingsOpen}
          icon={<SettingOutlined />}
          onClick={() => setSettingsOpen(true)}
          className={
            settingsOpen
              ? "!border-primary !text-primary"
              : undefined
          }
        >
          Calendar Settings
        </Button>

        {createAllowed && (
          <Button
            type={"primary"}
            size={"large"}
            onClick={onOpenAddModal}
            icon={<PlusOutlined />}
          >
            Event
          </Button>
        )}
      </Flex>

      <CalendarSettingsDrawer
        open={settingsOpen}
        accountTimezone={accountTimezone}
        onClose={() => setSettingsOpen(false)}
      />
    </div>
  )
}
